import React from 'react';
import type BulkEmailType from '@atlassian/jira-admin-pages-bulk-email/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyBulkEmail = lazyForPaint<typeof BulkEmailType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-admin-pages-bulk-email", jiraSpaEntry: "jira-admin-pages-bulk-email" */ '@atlassian/jira-admin-pages-bulk-email'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyBulkEmail} pageId="jira-admin-pages-bulk-email" shouldShowSpinner />
);
